import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {ActivityCardCreatedBy} from "~/modules/activityTimeline/types/activityTimeline.types";
import {isDeprecatedSystemGeneratedCreatedUpdatedByUserId} from "~/utilities/deprecatedSystemGeneratedCreatedUpdatedByUserIds";

export const ACTIVITY_TIMELINE_SYSTEM_CREATED_BY_DISPLAY_NAME = "Ottopilot";

export function toActivityCardCreatedBy(userId: Uuid | null | undefined): ActivityCardCreatedBy {
    if (userId === null || userId === undefined) {
        return {
            kind: "system",
            userId: null,
        };
    }
    if (isDeprecatedSystemGeneratedCreatedUpdatedByUserId(userId) === true) {
        return {
            kind: "system",
            userId: userId,
        };
    }
    return {
        kind: "user",
        userId: userId,
    };
}
